// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', function () {
  // Find the countdown container
  const countdownContainer = document.querySelector('[data-footer-countdown-date]')
  
  if (!countdownContainer) {
    return
  }
  
  // Find the countdown elements
  const daysEl = document.getElementById('footer-countdown-days')
  const hoursEl = document.getElementById('footer-countdown-hours')
  const minutesEl = document.getElementById('footer-countdown-minutes')
  const secondsEl = document.getElementById('footer-countdown-seconds')
  
  // Find completion elements
  const completionEl = document.getElementById('countdown-completion')
  const runningButtonEl = document.getElementById('countdown-button-running')
  const completeButtonEl = document.getElementById('countdown-button-complete')
  const liveIndicatorEl = document.getElementById('live-indicator')
  const countdownSectionEl = document.getElementById('footer-countdown-section')
  const footerMainEl = document.querySelector('[data-footer-main]')
  
  // Find background elements
  const backgroundBeforeEl = document.getElementById('countdown-background-before')
  const backgroundAfterEl = document.getElementById('countdown-background-after')
  
  // Function to switch backgrounds with smooth transition
  function switchBackground(toAfter = false) {
    if (toAfter) {
      // Pause videos in before background
      if (backgroundBeforeEl) {
        const videos = backgroundBeforeEl.querySelectorAll('video')
        videos.forEach(video => {
          video.pause()
        })
        backgroundBeforeEl.classList.add('hidden')
      }
      
      // Play videos in after background
      if (backgroundAfterEl) {
        backgroundAfterEl.classList.remove('hidden')
        const videos = backgroundAfterEl.querySelectorAll('video')
        videos.forEach(video => {
          video.play().catch(e => console.log('Video autoplay failed:', e))
        })
      }
    } else {
      // Pause videos in after background
      if (backgroundAfterEl) {
        const videos = backgroundAfterEl.querySelectorAll('video')
        videos.forEach(video => {
          video.pause()
        })
        backgroundAfterEl.classList.add('hidden')
      }
      
      // Play videos in before background
      if (backgroundBeforeEl) {
        backgroundBeforeEl.classList.remove('hidden')
        const videos = backgroundBeforeEl.querySelectorAll('video')
        videos.forEach(video => {
          video.play().catch(e => console.log('Video autoplay failed:', e))
        })
      }
    }
  }

  function hideFooterCountdownSection() {
    if (countdownSectionEl) {
      countdownSectionEl.style.display = 'none'
    }
  }

  function setFooterPadding(addPadding) {
    if (!footerMainEl) return
    footerMainEl.style.paddingBottom = addPadding ? '10rem' : ''
  }
  
  // Initialize background state
  function initializeBackground() {
    // Check if countdown has already completed
    const targetDate = countdownContainer.getAttribute('data-footer-countdown-date')
    const targetDateTime = new Date(targetDate + 'T00:00:00').getTime()
    const now = new Date().getTime()
    const distance = targetDateTime - now
    
    if (distance < 0) {
      // Countdown already complete, show after background
      switchBackground(true)
      hideFooterCountdownSection()
      setFooterPadding(true)
      // Show LIVE indicator if countdown is already complete
      if (liveIndicatorEl) {
        liveIndicatorEl.classList.remove('hidden')
      }
    } else {
      // Countdown still running, show before background
      switchBackground(false)
      setFooterPadding(false)
    }
  }
  
  function startCountdown() {
    const targetDate = countdownContainer.getAttribute('data-footer-countdown-date')
    const targetDateTime = new Date(targetDate + 'T00:00:00').getTime()
    
    function updateCountdown() {
      const now = new Date().getTime()
      const distance = targetDateTime - now
      
      if (distance < 0) {
        // Countdown complete - hide timer and show completion text
        countdownContainer.style.display = 'none'
        
        if (completionEl) {
          completionEl.classList.remove('hidden')
        }
        
        // Show LIVE indicator
        if (liveIndicatorEl) {
          liveIndicatorEl.classList.remove('hidden')
        }
        
        // Hide running button
        if (runningButtonEl) {
          runningButtonEl.classList.add('hidden')
        }
        
        // Show completion button
        if (completeButtonEl) {
          completeButtonEl.classList.remove('hidden')
        }
        
      // Switch to after countdown background
      switchBackground(true)
      hideFooterCountdownSection()
      setFooterPadding(true)
      
      return
      }
      
      const days = Math.floor(distance / (1000 * 60 * 60 * 24))
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
      const seconds = Math.floor((distance % (1000 * 60)) / 1000)
      
      if (daysEl) daysEl.textContent = days.toString()
      if (hoursEl) hoursEl.textContent = hours.toString().padStart(2, '0')
      if (minutesEl) minutesEl.textContent = minutes.toString().padStart(2, '0')
      if (secondsEl) secondsEl.textContent = seconds.toString().padStart(2, '0')
    }
    
    // Update immediately and then every second
    updateCountdown()
    setInterval(updateCountdown, 1000)
  }
  
  // Initialize background and start the countdown
  initializeBackground()
  startCountdown()
})
